import React from 'react';
import { Button, Text } from "@paro.io/base-ui";

interface AgreeDisagreeQuestionProps {
    title: string,
    description?: string,
    status: boolean | null,
    onAgreeClick(): any,
    onDisagreeClick(): any,
    buttonProps?: Array<any>,
}

const AgreeDisagreeQuestion = ({ title, description, status, onAgreeClick, onDisagreeClick, buttonProps }: AgreeDisagreeQuestionProps) => {
    const onButtonClick = (e, action) => {
        e.preventDefault();
        action();
    }

    let buttonProperties = [{
        label: "Yes",
        color: status ? "primary" : "default",
        onClick: (e) => onButtonClick(e, onAgreeClick),
        ...(buttonProps && buttonProps[0])
    }, {
        label: "No",
        color: !status ? "primary" : "default",
        onClick: (e) => onButtonClick(e, onDisagreeClick),
        ...(buttonProps && buttonProps[1])
    }]

    return (
        <div className="pb-2">
            <Text size="h6">{title}</Text>
            {description && <Text className="text-grey mb-2" size="sm">{description}</Text>}
            <div className="flex">
                <div className="pr-2 w-full md:w-auto">
                    <Button className="px-4 md:px-8 w-full" {...buttonProperties[0]} />
                </div>
                <div className="pl-2 w-full md:w-auto">
                    <Button className="px-4 md:px-8 w-full" {...buttonProperties[1]} />
                </div>
            </div>
        </div>)
}

export default AgreeDisagreeQuestion;